"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1223],{

/***/ 5472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7379);
/* harmony import */ var _Base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(573);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3887);

// components

// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          &::before {\n            background-color: rgba(0, 0, 0, 0.04);\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        &::before {\n          background-color: rgba(0, 0, 0, 0.04);\n        }\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  border: 1px solid\n    ",
        ";\n\n  background-color: ",
        ";\n\n  color: ",
        ";\n\n  &::before {\n    background-color: rgba(0, 0, 0, 0);\n  }\n\n  ",
        " {\n    &:hover {\n      ",
        ";\n    }\n  }\n\n  &:active {\n    ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var OutlineButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_Base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f51b163f-0"
})(_templateObject2(), function(param) {
    var color = param.color, disabled = param.disabled;
    if (!disabled) {
        if (color === 'Red') {
            return _styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.red040 */ .DG.red040;
        }
        if (color === 'Grey') {
            return _styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey050 */ .DG.grey050;
        }
    }
    if (disabled) {
        return _styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey030 */ .DG.grey030;
    }
    return color;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.white */ .DG.white, function(param) {
    var color = param.color, disabled = param.disabled;
    if (!disabled) {
        if (color === 'Red') {
            return _styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.red040 */ .DG.red040;
        }
        if (color === 'Grey') {
            return _styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey060 */ .DG.grey060;
        }
    }
    if (disabled) {
        return _styles__WEBPACK_IMPORTED_MODULE_1__/* .palette.grey030 */ .DG.grey030;
    }
    return color;
}, _styles__WEBPACK_IMPORTED_MODULE_1__/* .onlyHover */ .kC, function(param) {
    var disabled = param.disabled;
    return !disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
}, function(param) {
    var disabled = param.disabled;
    return !disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
});
/* harmony default export */ __webpack_exports__["Z"] = (OutlineButton);


/***/ }),

/***/ 9604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7379);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3887);


// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  z-index: ",
        ";\n\n  & > div:first-child {\n    display: block;\n  }\n\n  & > div:last-child {\n    display: none;\n  }\n\n  ",
        " {\n    display: block;\n\n    & > div:first-child {\n      display: none;\n    }\n\n    & > div:last-child {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * 상단 헤더 레이아웃 (Mobile, PC 구분)
 * @param {object} props
 * @param {JSX.Element} props.mobile
 * @param {JSX.Element} props.pc
 *
 * @example
 * <HeadLayout
 *   mobile={<Mobile_Header />}
 *   pc={<PC_Header />}
 * />
 */ var HeadLayout = function(param) {
    var mobile = param.mobile, pc = param.pc;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Layout, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: mobile
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: pc
            })
        ]
    }));
};
var Layout = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-4f33893c-0"
})(_templateObject(), cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .zIndex.header */ .W5.header, cds_styles__WEBPACK_IMPORTED_MODULE_1__/* .mediaQuery.large */ .cy.large);
/* harmony default export */ __webpack_exports__["Z"] = (HeadLayout);


/***/ }),

/***/ 4847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7379);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6643);
/* harmony import */ var cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5549);
/* harmony import */ var cds_buttons_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8163);
/* harmony import */ var lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7496);
/* harmony import */ var cds_typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(506);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3887);




// components



// utils

// styles


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: ",
        ";\n  width: 100%;\n  padding: 48px 16px 64px;\n  background-color: ",
        ";\n  z-index: ",
        ";\n\n  ",
        " {\n    display: ",
        ";\n    padding: 48px 0 64px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 1800px;\n  max-width: 100%;\n\n  ",
        " {\n    display: flex;\n    padding: 0 32px;\n    margin: 0 auto;\n  }\n\n  ",
        " {\n    display: flex;\n    padding: 0 72px;\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  a {\n    flex: 0 auto;\n    display: inline-block;\n    margin-bottom: 32px;\n    font-size: 0;\n\n    ",
        " {\n      margin-bottom: 0;\n    }\n\n    & svg {\n      ",
        " {\n        width: 140px;\n        height: 23px;\n      }\n    }\n  }\n\n  ",
        " {\n    flex: 0 auto;\n    width: 28%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        " {\n    & > * {\n      display: inline-block;\n      vertical-align: top;\n      width: calc(100% / 2);\n    }\n  }\n\n  ",
        " {\n    flex: 0 auto;\n    width: 72%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 32px;\n\n  ",
        " {\n    margin-bottom: 24px;\n\n    & ~ & {\n      padding-left: 16px;\n    }\n  }\n\n  & > span {\n    display: block;\n    ",
        "\n    font-weight: 400;\n    color: ",
        ";\n\n    ",
        " {\n      font-weight: 400;\n    }\n  }\n\n  & a {\n    color: ",
        ";\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 12px;\n  color: ",
        ";\n  ",
        " {\n    margin-bottom: 16px;\n    ",
        "\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 16px;\n\n  span {\n    margin-left: 4px;\n    ",
        "\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  max-width: 100%;\n  ",
        "\n  color: ",
        ";\n  background-color: ",
        ";\n\n  ",
        " {\n    width: 248px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 32px;\n\n  ",
        " {\n    margin-bottom: 24px;\n  }\n\n  & li {\n    overflow: hidden;\n    display: inline-block;\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n    background-color: ",
        ";\n    font-size: 0;\n    vertical-align: top;\n  }\n\n  & li ~ li {\n    margin-left: 16px;\n  }\n\n  & a {\n    display: flex;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n\n  ",
        " {\n    padding-left: 16px;\n    margin-bottom: 0;\n  }\n\n  & li {\n    width: auto;\n    font-size: 0;\n\n    ",
        " {\n      display: inline-block;\n      width: 50%;\n      vertical-align: top;\n      line-height: 40px;\n    }\n  }\n\n  & li:nth-child(even) {\n    ",
        " {\n      padding-left: 12px;\n    }\n\n    ",
        " {\n      padding-left: 32px;\n    }\n  }\n\n  & ",
        " {\n    background-color: rgba(0, 0, 0, 0);\n    ",
        "\n    color: ",
        ";\n    justify-content: flex-start;\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n\n  ",
        " {\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
/**
 * Footer
 * @param {object} props
 * @param {boolean} props.disableFooter
 */ var Footer = function(param) {
    var disableFooter = param.disableFooter;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isApp = ref[0], setIsApp = ref[1];
    // 고객센터 연결 - 카톡 플러스 친구 챗
    var onCustomerCenter = function() {
        if (!window.Kakao.isInitialized()) {
            window.Kakao.init("e1d49b55459efb99d8d231c4536e8923");
        }
        window.Kakao.PlusFriend.chat({
            plusFriendId: "_sqfxdxl"
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var device = (0,lib_utils_deviceChecker__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
        if (device.app()) {
            setIsApp(true);
        } else {
            setIsApp(false);
        }
    }, []);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Layout, {
        id: "footer",
        isDisplay: !isApp,
        isMobileDisplay: !disableFooter,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Logo, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            name: "logo_grey",
                            width: 110,
                            height: 19,
                            fill: cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey050 */ .DG.grey050
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Information, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Company, {
                                    children: "(주)클래스유"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "사업자번호 : 479-86-00516 | 대표자 : 김대형"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "통신판매업신고번호 : 제2019-서울마포-0108호"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "개인정보보호책임자 : Jacob, Kim(class_customer@enfit.net) 02-335-3320"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "서울특별시 중구 을지로 264, 1103호(을지로6가, 롯데FiTin)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Information, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CsCenter, {
                                    children: [
                                        "고객센터",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "(월-금 오전 08:30 ~ 오후 05:00)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CsButton, {
                                    type: "button",
                                    color: cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey030 */ .DG.grey030,
                                    size: 'Regular',
                                    onClick: onCustomerCenter,
                                    children: "카카오톡 문의하기"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Social, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        href: "https://www.instagram.com/classu._.official/",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                name: "ic_instagram",
                                                width: 22,
                                                height: 22,
                                                fill: cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey50 */ .DG.grey50,
                                                stroke: cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey50 */ .DG.grey50
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        href: "https://www.facebook.com/classtok/",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                name: "ic_facebook",
                                                width: 12,
                                                height: 22,
                                                fill: cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey50 */ .DG.grey50
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        href: "https://www.youtube.com/channel/UCQ9WEzhuxE4UR69Ku4kQVSA",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                name: "ic_youtube",
                                                width: 26,
                                                height: 18,
                                                fill: cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey50 */ .DG.grey50
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        href: "https://blog.naver.com/classu_official_",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                name: "ic_blog",
                                                width: 24,
                                                height: 21,
                                                fill: cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey50 */ .DG.grey50
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Policy, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        href: "https://classu.co.kr/new/biz",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_buttons_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            as: "a",
                                            rel: "noopener noreferrer",
                                            size: "Regular",
                                            target: "_blank",
                                            children: "기업/단체 교육 문의"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        href: "/notice",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_buttons_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            as: "a",
                                            rel: "noopener noreferrer",
                                            size: "Regular",
                                            children: "공지사항"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        href: "/customer/faq",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_buttons_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            as: "a",
                                            rel: "noopener noreferrer",
                                            size: "Regular",
                                            children: "FAQ"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        href: "/customer/agreement",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_buttons_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            as: "a",
                                            rel: "noopener noreferrer",
                                            size: "Regular",
                                            children: "이용약관"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                        href: "/customer/policy",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_buttons_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            as: "a",
                                            rel: "noopener noreferrer",
                                            size: "Regular",
                                            children: "개인정보처리방침"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Copyright, {
                            children: "\xa9 CLASSU Inc."
                        })
                    ]
                })
            ]
        })
    }));
};
var Layout = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].footer.withConfig */ .ZP.footer.withConfig({
    componentId: "sc-288676d2-0"
})(_templateObject(), function(param) {
    var isDisplay = param.isDisplay, isMobileDisplay = param.isMobileDisplay;
    return isDisplay && isMobileDisplay ? 'block' : 'none';
}, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.system.BLACK */ .DG.system.BLACK, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .zIndex.footer */ .W5.footer, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.large */ .cy.large, function(param) {
    var isDisplay = param.isDisplay;
    return isDisplay ? 'flex' : 'none';
});
var Inner = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-288676d2-1"
})(_templateObject1(), cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.large */ .cy.large, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.xlarge */ .cy.xlarge);
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-288676d2-2"
})(_templateObject2(), cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.large */ .cy.large, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.large */ .cy.large, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.large */ .cy.large);
var Content = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-288676d2-3"
})(_templateObject3(), cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.medium */ .cy.medium, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.large */ .cy.large);
var Information = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-288676d2-4"
})(_templateObject4(), cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.large */ .cy.large, cds_typography__WEBPACK_IMPORTED_MODULE_6__/* .caption2_medium */ .pn, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey25 */ .DG.grey25, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.large */ .cy.large, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey50 */ .DG.grey50);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-288676d2-5"
})(_templateObject5(), cds_typography__WEBPACK_IMPORTED_MODULE_6__/* .caption1_medium */ .VH, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey50 */ .DG.grey50);
var Company = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(Title).withConfig({
    componentId: "sc-288676d2-6"
})(_templateObject6(), cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey50 */ .DG.grey50, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.medium */ .cy.medium, cds_typography__WEBPACK_IMPORTED_MODULE_6__/* .subtitle4_medium */ .b_);
var CsCenter = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(Title).withConfig({
    componentId: "sc-288676d2-7"
})(_templateObject7(), cds_typography__WEBPACK_IMPORTED_MODULE_6__/* .caption3_regular */ .dK, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey25 */ .DG.grey25);
var CsButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(cds_buttons_Fill__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-288676d2-8"
})(_templateObject8(), cds_typography__WEBPACK_IMPORTED_MODULE_6__/* .body2_regular */ .Tk, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey50 */ .DG.grey50, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.BTN.BG */ .DG.BTN.BG, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.medium */ .cy.medium);
var Social = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-288676d2-9"
})(_templateObject9(), cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.medium */ .cy.medium, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.BTN.BG */ .DG.BTN.BG);
var Policy = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-288676d2-10"
})(_templateObject10(), cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.large */ .cy.large, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.medium */ .cy.medium, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.medium */ .cy.medium, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.xlarge */ .cy.xlarge, cds_buttons_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, cds_typography__WEBPACK_IMPORTED_MODULE_6__/* .caption3_medium */ .eH, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey25 */ .DG.grey25);
var Copyright = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-288676d2-11"
})(_templateObject11(), cds_typography__WEBPACK_IMPORTED_MODULE_6__/* .caption3_regular */ .dK, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .palette.grey25 */ .DG.grey25, cds_styles__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.medium */ .cy.medium);
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 3349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7379);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var components_molecules_modal_search_AutoComplete__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1461);
/* harmony import */ var cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7732);
/* harmony import */ var cds_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6643);
/* harmony import */ var slices_search_thunk__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7687);
/* harmony import */ var hooks_common_useStore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8004);
/* harmony import */ var hooks_common_event_useThrottle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2567);
/* harmony import */ var cds_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3887);




// components



// slices

// hooks


// styles

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  max-width: 640px;\n  height: 44px;\n  padding: 10px 20px;\n  border: ",
        ";\n  border-radius: 22px;\n  background-color: transparent;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1;\n  padding: 0 32px 0 0;\n  color: ",
        ";\n  border: none;\n  outline: none;\n  background-color: rgba(0, 0, 0, 0);\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  &::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 48px;\n  top: 10px;\n\n  &:active {\n    & svg {\n      transition: fill 0.1s ease;\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
/**
 * 헤더 검색 Input
 * @param {object} props
 * @param {'Light' | 'Dark'} props.mode 모드
 */ var SearchInput = function(_param) {
    var _mode = _param.mode, mode = _mode === void 0 ? 'Light' : _mode, props = _objectWithoutProperties(_param, [
        "mode"
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var keyword = router.query.keyword;
    var dispatch = (0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I)();
    var autoCompletedClassList = (0,hooks_common_useStore__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v)(function(state) {
        return state.search.autoCompletedKeywordList;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowAutoComplete = ref[0], setIsShowAutoComplete = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowErase = ref1[0], setIsShowErase = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), word = ref2[0], setWord = ref2[1];
    var searchRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var isMounted = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var isSearched = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var throttle = (0,hooks_common_event_useThrottle__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var onSearch = function() {
        if (!searchRef.current) {
            return;
        }
        var value = searchRef.current.value;
        value = value.replace(/#/g, '');
        router.push("/search?keyword=".concat(value));
    };
    var onAutoComplete = function(value) {
        setWord(value);
        dispatch((0,slices_search_thunk__WEBPACK_IMPORTED_MODULE_6__/* .postAutoCompleteKeyword */ .br)({
            keyword: value
        })).finally(function() {
            if (!isMounted.current) {
                return;
            }
            if (value.trim().length > 0 && !isSearched.current) {
                setIsShowAutoComplete(true);
                setIsShowErase(true);
            } else {
                setIsShowAutoComplete(false);
                setIsShowErase(false);
            }
        });
    };
    var onCloseAutoComplete = function() {
        setIsShowAutoComplete(false);
        setIsShowErase(false);
    };
    var onClear = function() {
        setIsShowAutoComplete(false);
        setIsShowErase(false);
        searchRef.current.value = '';
    };
    var onKeyPress = function(e) {
        if (e.key === 'Enter') {
            e.target.blur();
            onSearch();
            setIsShowAutoComplete(false);
            isSearched.current = true;
        } else {
            isSearched.current = false;
        }
    };
    var onChange = throttle.run(function(e) {
        var value = e.target.value;
        onAutoComplete(value);
    }, 400);
    var onFocus = function(e) {
        return window.setTimeout(function() {
            var value = e.target.value;
            isSearched.current = false;
            onAutoComplete(value);
        }, 100);
    };
    /** 초기화 작업 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        isSearched.current = false;
        isMounted.current = true;
        return function() {
            return isMounted.current = false;
        };
    }, []);
    /** 검색입력칸 값 변경 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (searchRef.current && keyword) {
            searchRef.current.value = keyword;
        }
    }, [
        keyword
    ]);
    /** 검색 후, 타 페이지 접속시 키워드 삭제하기 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (keyword) {
            return;
        }
        if (searchRef.current.value) {
            searchRef.current.value = '';
        }
    }, [
        keyword,
        searchRef
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Layout, {
        mode: mode,
        children: [
            isShowAutoComplete && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_molecules_modal_search_AutoComplete__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                keyword: word,
                keywordList: autoCompletedClassList,
                onClose: onCloseAutoComplete
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, _objectSpread({
                type: "text",
                placeholder: "무엇을 배우고 싶나요?",
                onFocus: onFocus,
                onKeyPress: onKeyPress,
                onChange: onChange,
                defaultValue: keyword,
                ref: searchRef,
                mode: mode
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchButton, {
                mode: mode,
                onClick: onSearch,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    name: "ic_search",
                    width: 24,
                    height: 24,
                    fill: cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.grey50 */ .DG.grey50
                })
            }),
            isShowErase && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EraseButton, {
                width: 32,
                height: 22,
                onClick: onClear,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(cds_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    name: "ic_close_circle_m",
                    width: 24,
                    height: 24,
                    fill: cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.BTN.BG */ .DG.BTN.BG
                })
            })
        ]
    }));
};
var Layout = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-df63f3d-0"
})(_templateObject(), function(param) {
    var mode = param.mode;
    return mode === 'Light' ? "1px solid ".concat(cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.system.grey */ .DG.system.grey) : "1px solid ".concat(cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.system.grey */ .DG.system.grey);
});
var Input = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-df63f3d-1"
})(_templateObject1(), function(param) {
    var mode = param.mode;
    return mode === 'Light' ? cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.grey75 */ .DG.grey75 : cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.white */ .DG.white;
}, function(param) {
    var mode = param.mode;
    return mode === 'Light' ? cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.grey0 */ .DG.grey0 : cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.font.tertiary2 */ .DG.font.tertiary2;
});
var SearchButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-df63f3d-2"
})(_templateObject2());
var EraseButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(cds_buttons_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-df63f3d-3"
})(_templateObject3(), cds_styles__WEBPACK_IMPORTED_MODULE_9__/* .palette.grey060 */ .DG.grey060);
/* harmony default export */ __webpack_exports__["Z"] = (SearchInput);


/***/ })

}]);